import { trapFocus, removeTrapFocus } from '@theme/focus';

// Determine if we're on staging based on the current domain
const _staging = window.location.hostname === 'baltimora-studio.myshopify.com' || 
                 window.location.hostname.includes('myshopify.com');

class NewsletterOverlayDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#NewsletterOverlayDrawer-Overlay').addEventListener('click', this.close.bind(this));
  
      this.setHeaderLinkAccessibility();
    }
  
    setHeaderLinkAccessibility() {
      if (this.shouldOpenForSuccess()) {
        this.open();
        return;
      }

      /* Logic */
      const overlay = document.querySelector('newsletter-overlay');
      if (!overlay) return;

      const _options = JSON.parse(overlay.getAttribute('data-section-settings'));
      if((typeof _options !== 'undefined' && !_options['showOnlyOnce']) || (_options['showOnlyOnce'] && this.getCookie('nl_overlay') === null )) {
        const delaySeconds = typeof _options['apparitionDelay'] !== 'undefined' ? _options['apparitionDelay'] : 0;
        const minDelaySeconds = 5;
        const effectiveDelay = Math.max(delaySeconds, minDelaySeconds);

        // Defer overlay until after first user interaction (reduces INP/friction on entry)
        const openWhenReady = () => setTimeout(this.open.bind(this), effectiveDelay * 1000);
        const onFirstInteraction = () => {
          window.removeEventListener('pointerdown', onFirstInteraction, true);
          window.removeEventListener('keydown', onFirstInteraction, true);
          openWhenReady();
        };

        window.addEventListener('pointerdown', onFirstInteraction, true);
        window.addEventListener('keydown', onFirstInteraction, true);
      }
      /* Logic */
    }

    shouldOpenForSuccess() {
      const popupSuccess = document.querySelector(
        '.shopify-nl-form--popup[data-nl-posted-successfully]'
      );
      const wasPopupSubmit =
        sessionStorage.getItem('nl-popup-submitted') === '1';

      sessionStorage.removeItem('nl-popup-submitted');

      if (popupSuccess) {
        return true;
      }

      return (
        wasPopupSubmit &&
        window.location.search.includes('customer_posted=true')
      );
    }
  
    open() {
      /* Custom Scrollbar - create */
      // if(matchMedia('(hover: hover), (pointer: fine)').matches && !Scrollbar.has(document.querySelector('country-drawer #selectCountryWrapper'))) CountryDrawerScrollbar = Scrollbar.init(document.querySelector('country-drawer #selectCountryWrapper'));
      /* Custom Scrollbar - create */
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {this.classList.add('animate', 'active')});
  
      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('NewsletterOverlayDrawer');
        if (containerToTrapFocusOn instanceof HTMLElement) {
          trapFocus(containerToTrapFocusOn);
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          if (focusElement instanceof HTMLElement) {
            focusElement.focus();
          }
        }
      }, { once: true });
  
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('newsletter-overlay-open');
    }
  
    close() {
      this.classList.remove('active');
      removeTrapFocus();
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('newsletter-overlay-open');
      /* Custom Scrollbar - go up */
      // if(typeof Scrollbar !== 'undefined' && typeof Scrollbar.get(document.querySelector('cart-drawer-items')) !== 'undefined') setTimeout(() => {Scrollbar.get(document.querySelector('cart-drawer-items')).scrollTop = 0});
      /* Custom Scrollbar - go up */
      /* Logic */
      //if(event.target.matches('.newsletter-overlay-drawer__overlay')) return;
      this.updateCookie('nl_overlay','1',false);
      /* Logic */
    }
  
    clearCookie(key) {
      this.updateCookie(key,'',true)
    }
  
    updateCookie(key,value,deleteCookie) {
      const domain = _staging ? 'baltimora-studio.myshopify.com' : 'paristexasbrand.com';
      let expires = '';
      if(deleteCookie) {
        let d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*-1);
        expires = `;expires=${d.toGMTString()}`;
      }
      document.cookie = `${key}=${value};path=/;domain=${domain}${expires}`;
    }
  
    getCookie(name) {
      const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    }
  
  }
  
  customElements.define('newsletter-overlay', NewsletterOverlayDrawer);
  